import React, { useState, useEffect, useCallback } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

export default function ImageGallery() {
  const [images, setImages] = useState([]);

  const fetchGalleryImage = useCallback(async () => {
    try {
      const response = await fetch(`/api/getGalleryImage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ activeInactive: 1 }),
      });

      if (response.ok) {
        const Data = await response.json();
        setImages(Data);
      } else {
        console.error("Error fetching filtered data");
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  }, []);

  useEffect(() => {
    fetchGalleryImage();
  }, [fetchGalleryImage]);

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <>
      <section className="bg-gradient-to-r from-red-600 to-[#ff4e1c] py-24 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold" data-aos="fade-down">
            Image Gallery
          </h1>
          <p className="mt-3 text-sky-100 text-base md:text-lg" data-aos="fade-up" data-aos-delay="150">
            A Visual Journey Through the Vibrant Life at <span>Krishna Public School</span>
          </p>
        </div>
      </section>
      <div className="container my-5 py-5 bg-light text-dark shadow-lg p-3 mb-5 bg-white rounded">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900" data-aos="fade-up">
            Explore Our Captivating Image Gallery
          </h2>
          <div className="w-24 h-1 bg-[#ff4e1c] mx-auto mt-4 rounded-full" data-aos="zoom-in" data-aos-delay="150"></div>
        </div>
        <div className="row">
          {images.map((image, index) =>
            <div key={index} className={`col-md-4   ${index === 0 ? 'active' : ''}`} data-aos="zoom-in" data-aos-delay={index * 120}>
              <div className="image-containers shadow p-3 mb-5 bg-white rounded">
                <img src={`/ImageGallery/${image.ImageURL}?timestamp=${new Date().getTime()}`} className="d-block w-100 h-auto img" alt={image.ImageTitle} />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
